import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { UtensilsIcon, BookOpenIcon, ThermometerIcon, MoonIcon, HeartIcon, DumbbellIcon, SparklesIcon, DownloadIcon } from 'lucide-react';
const includes = [{
  icon: UtensilsIcon,
  text: 'Más de 100 recetas antiinflamatorias diseñadas para apoyar el equilibrio hormonal.'
}, {
  icon: BookOpenIcon,
  text: 'Guía práctica de alimentación para reducir inflamación y estabilizar energía.'
}, {
  icon: ThermometerIcon,
  text: 'Estrategias naturales para manejar sofocos, ansiedad, irritabilidad y niebla mental.'
}, {
  icon: MoonIcon,
  text: 'Hábitos diarios para disminuir el estrés y mejorar el sueño.'
}, {
  icon: HeartIcon,
  text: 'Técnicas para mejorar digestión y apoyar la microbiota.'
}, {
  icon: DumbbellIcon,
  text: 'Rutinas simples para recuperar fuerza y vitalidad.'
}, {
  icon: SparklesIcon,
  text: 'Ejercicios de reconexión corporal y autoestima femenina.'
}, {
  icon: DownloadIcon,
  text: 'Formato digital de acceso inmediato para comenzar hoy mismo.'
}];
export function WhatYouGet() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-16 px-4 bg-white" ref={ref} data-id="element-171">
      <div className="max-w-5xl mx-auto" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-173">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D2926] mb-4" data-id="element-174">
            ACCESO COMPLETO A LA GUÍA MENOPAUSIA EN CALMA
          </h2>
          <p className="text-xl text-[#7C9A6E] font-medium" data-id="element-175">Incluye:</p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-176">
          {includes.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} animate={isInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start gap-4 p-5 bg-[#FAF7F2] rounded-xl border border-[#7C9A6E]/20 hover:border-[#7C9A6E]/40 transition-colors" data-id="element-177">
                <div className="w-12 h-12 rounded-full bg-[#7C9A6E]/10 flex items-center justify-center flex-shrink-0" data-id="element-178">
                  <Icon className="w-6 h-6 text-[#7C9A6E]" data-id="element-179" />
                </div>
                <p className="text-[#2D2926]/90 leading-relaxed pt-2" data-id="element-180">
                  {item.text}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}